import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AdvanceTable from "components/common/advance-table/AdvanceTable";
import SubtleBadge from "components/common/SubtleBadge";
import { ViewClaim } from "features/cliams/config/cliamApi";
import useAdvanceTable from "hooks/useAdvanceTable";
import moment from "moment";
import AdvanceTableProvider from "providers/AdvanceTableProvider";
import { useAppContext } from "providers/AppProvider";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import paths from "routes/paths";

const CLaimSingleViewTable = ({ data, fromPage, setShow, date }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const {
        config: { isDark }
    } = useAppContext();


    const handleViewClaimRequest = async (row) => {
        if (fromPage) {
            setShow(false);
            return;
        }
        const response = await dispatch(
            ViewClaim({
                claimid: row?.pollsabout,
                claim_type: row?.claim_type,
            })
        ).unwrap();

        if (response?.success) {

            navigate(
                `${paths.viewClaimRequest}/${row?.pollsabout}?claim_type=${row?.claim_type}`
            );


        }
    };

    const columns = [
        {
            accessorKey: "index",
            header: "#",
            cell: ({ row: { original, index } }) => (
                <div className="d-flex align-items-center w-100">
                    <div
                        className="rounded-circle bg-200 d-flex flex-center fs-11"
                        style={{ width: "30px", height: "30px" }}
                    >
                        {index + 1}
                    </div>
                </div>
            ),
        },
        {
            accessorKey: "claim_number",
            header: "Claim Number",
            cell: ({ row: { original, index } }) => (
                <OverlayTrigger
                    placement="bottom"

                    overlay={
                        <Tooltip
                            id={`tooltip-claim-${index}`}
                            style={{
                                "--bs-tooltip-bg": "transparent",
                                "--bs-tooltip-padding-y": "0",
                                "--bs-tooltip-padding-x": "0",
                            }}

                        >
                            <div className={isDark ? "bg-dark" : "bg-white"}
                                style={{
                                    padding: "12px 16px",
                                    textAlign: "left",
                                    borderRadius: "12px",
                                    background: "rgba(11, 23, 39, 0.95)",
                                    backdropFilter: "blur(10px)",
                                    border: isDark ? "1px solid rgba(255, 255, 255, 0.15)" : "1px solid rgba(0, 0, 0, 0.1)",
                                    boxShadow: isDark ? "0 20px 40px rgba(0,0,0,0.4)" : "0 10px 30px rgba(0,0,0,0.1)",
                                    width: "300px",
                                    minWidth: "280px",
                                    maxWidth: "600px",
                                    zoom: "75%"
                                }}

                            >
                                <div
                                    className="d-flex align-items-center gap-2"
                                >

                                    <span
                                        style={{
                                            fontSize: "0.8rem",
                                            fontWeight: "800",
                                            textTransform: "uppercase",
                                            letterSpacing: "0.1rem",
                                            color: isDark ? "rgba(255, 255, 255, 0.5)" : "rgba(0, 0, 0, 0.5)",
                                        }}
                                    >
                                        view claim request page
                                    </span>
                                </div>

                            </div>
                        </Tooltip>
                    }
                >
                    <div
                        className="d-flex align-items-center w-100"
                        style={{
                            cursor: "pointer",
                            transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                        }}
                        onClick={() => handleViewClaimRequest(original)}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "translateY(-1px)";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "translateY(0)";
                        }}
                    >
                        <div className="flex-center fs-11 text-primary fw-semi-bold">
                            {original?.pollsabout || ''}
                        </div>
                    </div>
                </OverlayTrigger>
            ),
        },
        {
            accessorKey: "claim_date",
            header: "Claim Date",
            cell: ({ row: { original } }) => (
                <div className="d-flex align-items-center w-100">
                    <div className="flex-center cursor-pointer fs-11">
                        {date ? moment(date).format("DD-MM-YYYY") : '' || ''}
                    </div>
                </div>
            ),
        },
        {
            accessorKey: "insurance_code",
            header: "Insurance Code",
            cell: ({ row: { original } }) => (
                <div className="d-flex align-items-center w-100">
                    <div className="flex-center cursor-pointer fs-11">
                        {original?.insurance_code || ''}
                    </div>
                </div>
            ),
        },
        {
            accessorKey: "amount",
            header: "Amount",
            cell: ({ row: { original } }) => (
                <div className="d-flex align-items-center w-100">
                    <div className="flex-center cursor-pointer fs-11">
                        {original?.amount || ''}
                    </div>
                </div>
            ),
        },
        {
            accessorKey: "payment",
            header: "Payment Fee",
            cell: ({ row: { original } }) => (
                <div className="d-flex align-items-center w-100">
                    <div className="flex-center cursor-pointer fs-11">
                        {original?.payment || ''}
                    </div>
                </div>
            ),
        },
        {
            accessorKey: "earlyfee",
            header: "Early Fee",
            cell: ({ row: { original } }) => (
                <div className="d-flex align-items-center w-100">
                    <div className="flex-center cursor-pointer fs-11">
                        {original?.earlyfee || ''}
                    </div>
                </div>
            ),
        },
        {
            accessorKey: "nphiesfee",
            header: "Nphies Fee",
            cell: ({ row: { original } }) => (
                <div className="d-flex align-items-center w-100">
                    <div className="flex-center cursor-pointer fs-11">
                        {original?.nphiesfee || ''}
                    </div>
                </div>
            ),
        },
        {
            accessorKey: "paymenttype",
            header: "Payment Type",
            cell: ({ row: { original } }) => (
                <div className="d-flex align-items-center w-100">
                    <div className="flex-center cursor-pointer fs-11">
                        {original?.paymenttype || ''}
                    </div>
                </div>
            ),
        },
        {
            accessorKey: "claim_status",
            header: "Status",
            cell: ({ row: { original } }) => {
                const value = original.claim_status?.toLowerCase();
                const statusConfig = {
                    error: { bg: "#fde6d8", color: "#ac5a2b", icon: "exclamation" },
                    Error: { bg: "#fde6d8", color: "#ac5a2b", icon: "exclamation" },
                    invalid: { bg: "#fde6d8", color: "#ac5a2b", icon: "exclamation" },
                    "no response": {
                        bg: "#08101b",
                        color: "#91979e",
                        icon: "circle-exclamation", // clearer alert icon
                    }, // NEW

                    approved: { bg: "#d9f8eb", color: "#00894f", icon: "check" },
                    valid: { bg: "#e6e8ec", color: "#5d6776", icon: "check" },
                    rejected: { bg: "#fbdbe1", color: "#b82c46", icon: "times" },
                    cancelled: { bg: "#ffe0fe", color: "#da23aa", icon: "times" },
                    partial: {
                        bg: "#C2EEF6",
                        color: "#0da9bd",
                        icon: "star-half-stroke",
                    },
                    "partially approved": {
                        bg: "#C2EEF6",
                        color: "#0da9bd",
                        icon: "star-half-stroke",
                    },
                    pended: { bg: "#d9e7fa", color: "#215cac", icon: "clock" },
                    "not-required": {
                        bg: "#d8f3ff",
                        color: "#197aa4",
                        icon: "clock",
                    },
                    queued: { bg: "#fefad2", color: "#a7970d", icon: "list" },
                    adjudication: { bg: "#e8dff7", color: "#6f42c1", icon: "gavel" },

                    prepared: { bg: "#e6e8ec", color: "#5d6776", icon: "hammer" }, // NEW
                };

                const config = statusConfig[value] || {
                    bg: "#f8f9fa",
                    color: "#000",
                    icon: "question",
                };

                return (
                    <div className="d-flex justify-content-start w-100">
                        <SubtleBadge
                            pill
                            style={{
                                backgroundColor: config.bg,
                                color: config.color,
                                border: `1px solid ${config.color}20`,
                                width: "120px",
                            }}
                            className="d-flex flex-center fs-12 p-2 gap-1"
                        >
                            <FontAwesomeIcon
                                icon={config.icon}
                                transform="shrink-2"
                                className="ms-1 me-1"
                            />
                            {value ? value.charAt(0).toUpperCase() + value.slice(1) : "-"}
                        </SubtleBadge>
                    </div>
                );
            },
        },

    ]

    const table = useAdvanceTable({
        data,
        columns,
        manualPagination: false,

    });
    return (
        <>
            {data?.length > 0 ? (
                <>
                    <AdvanceTableProvider {...table}>
                        <AdvanceTable
                            tableProps={{
                                size: "sm",
                                className: "fs-10 mb-0 overflow-hidden",
                                striped: true,
                                hover: true,
                            }}
                            headerClassName="bg-200 text-nowrap align-middle"
                            rowClassName="align-middle white-space-nowrap"
                        />
                    </AdvanceTableProvider>
                </>
            ) : (
                <></>
            )}
        </>
    )
}


export default CLaimSingleViewTable;